// extracted by mini-css-extract-plugin
module.exports = {"lossCauseRadioButton":"TypeOfIncidentPage_lossCauseRadioButton__6lXwc"};